export interface ManualDayEntryFormValues {
    lottoSalesAmount: string;
    lottoPayoutsAmount: string;
    cashCollectionAmount: string;
    creditCardCollectionAmount: string;
}

export interface ManualDayEntryEditability {
    lotto: boolean;
    collections: boolean;
}

export interface StoreManualDayEntryUpsertPayload {
    business_date: string;
    lotto_sales_amount: number | null;
    lotto_payouts_amount: number | null;
    cash_collection_amount: number | null;
    credit_card_collection_amount: number | null;
}

export const EMPTY_MANUAL_DAY_ENTRY_FORM: ManualDayEntryFormValues = {
    lottoSalesAmount: '',
    lottoPayoutsAmount: '',
    cashCollectionAmount: '',
    creditCardCollectionAmount: '',
};

export const getManualDayEntryEditability = ({
    isBothNotConnected = false,
    isLottoConnectedOnly = false,
    isPOSConnectedOnly = false,
}: {
    isBothNotConnected?: boolean;
    isLottoConnectedOnly?: boolean;
    isPOSConnectedOnly?: boolean;
}): ManualDayEntryEditability => ({
    lotto: isBothNotConnected || isPOSConnectedOnly,
    collections: isBothNotConnected || isLottoConnectedOnly,
});

const toNullableAmount = (value: string): number | null => {
    const trimmed = value.trim();
    if (!trimmed) return null;

    const parsed = Number(trimmed.replace(/,/g, ''));
    if (!Number.isFinite(parsed) || parsed < 0) return null;

    return parsed;
};

export const buildManualDayEntryRequest = (
    businessDate: string,
    formValues: ManualDayEntryFormValues,
    editability: ManualDayEntryEditability
):
    | { type: 'delete' }
    | { type: 'upsert'; payload: StoreManualDayEntryUpsertPayload } => {
    const payload: StoreManualDayEntryUpsertPayload = {
        business_date: businessDate,
        lotto_sales_amount: editability.lotto ? toNullableAmount(formValues.lottoSalesAmount) : null,
        lotto_payouts_amount: editability.lotto ? toNullableAmount(formValues.lottoPayoutsAmount) : null,
        cash_collection_amount: editability.collections ? toNullableAmount(formValues.cashCollectionAmount) : null,
        credit_card_collection_amount: editability.collections ? toNullableAmount(formValues.creditCardCollectionAmount) : null,
    };

    const hasAnyManualValue = (
        payload.lotto_sales_amount !== null ||
        payload.lotto_payouts_amount !== null ||
        payload.cash_collection_amount !== null ||
        payload.credit_card_collection_amount !== null
    );

    if (!hasAnyManualValue) {
        return { type: 'delete' };
    }

    return { type: 'upsert', payload };
};

